import { service } from '../../../../helpers/http'

export const ActionGetCourseClusters = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourseCluster',
        action: 'getCourseClusters',
        payload: payload
    })
    
}

export const ActionPostCourseCluster = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourseCluster',
        action: 'postCourseCluster',
        payload: payload
    })
    
}

export const ActionPutCourseCluster = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourseCluster',
        action: 'putCourseCluster',
        payload: payload
    })
    
}

export const ActionDeleteCourseCluster = ({ dispatch }, payload) => {

    return service({
        module: 'domainCourseCluster',
        action: 'deleteCourseCluster',
        payload: payload
    })
    
}